import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const FullForecastLogo = ({size, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '176';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '62';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width="176" height="62" viewBox="0 0 176 62" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M50.5939 21.9481L37.6496 14.3991C37.0929 14.0496 36.3273 14.0496 35.7706 14.3991L22.7568 21.9481C22.2 22.2976 21.7825 22.9267 21.7825 23.6257V38.6539C21.7825 39.3529 22.1304 39.982 22.7568 40.3314L35.7706 47.8805C36.3273 48.23 37.0929 48.23 37.6496 47.8805L50.6635 40.3314C51.2202 39.982 51.6377 39.3529 51.6377 38.6539V23.6257C51.5682 22.9267 51.2202 22.2976 50.5939 21.9481ZM41.1988 33.4814L37.4408 35.6482V38.8636C37.4408 39.5626 37.0929 40.1916 36.4665 40.5411L33.6828 42.1488V34.5998C33.6828 33.9008 34.0308 33.2717 34.6571 32.9222L41.1292 29.1477V33.4814H41.1988ZM41.1988 24.814L33.7524 29.1477V25.9323C33.7524 25.2334 34.1004 24.6043 34.7267 24.2548L41.1988 20.4803V24.814Z"
					fill="#6E0FEA"
				/>
				<path
					d="M64.6516 38.2344H68.1312V33.1319H73.8378V30.0563H68.1312V27.1206H75.5081V24.045H64.6516V38.2344Z"
					fill="#6E0FEA"
				/>
				<path
					d="M81.2843 27.2604C78.083 27.2604 75.4385 29.4971 75.4385 32.8523C75.4385 36.2773 78.0134 38.4441 81.2843 38.4441C84.4855 38.4441 87.1301 36.2074 87.1301 32.8523C87.1301 29.4971 84.5551 27.2604 81.2843 27.2604ZM81.2843 35.6482C79.8924 35.6482 78.7093 34.5997 78.7093 32.9222C78.7093 31.2446 79.8924 30.1961 81.2843 30.1961C82.6761 30.1961 83.8592 31.3145 83.8592 32.9222C83.8592 34.5298 82.7457 35.6482 81.2843 35.6482Z"
					fill="#6E0FEA"
				/>
				<path
					d="M130.347 28.4487C129.443 27.6798 128.329 27.2604 127.076 27.2604C124.223 27.2604 121.857 29.4971 121.857 32.8523C121.857 36.2773 124.153 38.4441 127.076 38.4441C128.329 38.4441 129.443 38.0248 130.347 37.2559V38.0946H133.688V27.6099H130.347V28.4487ZM127.772 35.6482C126.38 35.6482 125.197 34.5997 125.197 32.9222C125.197 31.2446 126.38 30.1961 127.772 30.1961C129.164 30.1961 130.347 31.3145 130.347 32.9222C130.347 34.5298 129.164 35.6482 127.772 35.6482Z"
					fill="#6E0FEA"
				/>
				<path
					d="M108.425 32.9222C108.425 29.5671 105.92 27.3303 102.858 27.3303C99.7959 27.3303 97.2905 29.5671 97.2905 32.9222C97.2905 36.3472 99.7959 38.5141 102.858 38.5141C105.155 38.5141 107.173 37.2559 108.008 35.2289L105.015 34.5998C104.598 35.3687 103.832 35.788 102.928 35.788C101.814 35.788 100.84 35.0192 100.561 33.8309H108.356C108.425 33.4814 108.425 33.2018 108.425 32.9222ZM105.085 31.9436H102.928H102.162H100.701H100.631C100.631 30.8951 101.814 30.0564 102.928 30.0564C103.971 30.0564 105.085 30.8951 105.085 31.9436Z"
					fill="#6E0FEA"
				/>
				<path
					d="M115.385 35.6482C114.062 35.6482 112.949 34.5998 112.949 32.9222C112.949 31.2446 114.062 30.1962 115.385 30.1962C116.428 30.1962 117.264 30.8252 117.681 31.8737L120.813 31.1048C120.047 28.7982 117.96 27.3303 115.454 27.3303C112.322 27.3303 109.748 29.5671 109.748 32.9222C109.748 36.3472 112.322 38.5141 115.454 38.5141C117.96 38.5141 120.117 37.0462 120.813 34.7396L117.681 33.9707C117.333 35.0192 116.428 35.6482 115.385 35.6482Z"
					fill="#6E0FEA"
				/>
				<path
					d="M158.741 24.4645L158.045 25.8624L157.349 24.4645H156.932V26.4216H157.28V25.0936L157.906 26.4216H158.115L158.741 25.0936V26.4216H159.089V24.4645H158.741Z"
					fill="#6E0FEA"
				/>
				<path d="M154.913 24.7439H155.609V26.4207H155.957V24.7439H156.652V24.4645H154.913V24.7439Z" fill="#6E0FEA" />
				<path
					d="M95.8987 27.4701C94.5069 27.4701 93.115 28.0293 92.0015 29.0778L90.7489 27.6099H88.9395V38.2345H91.7232H92.2799V34.9492C92.2799 32.2931 93.463 30.965 95.8987 30.965H96.5251L96.6642 27.6099C96.3859 27.4701 96.1771 27.4701 95.8987 27.4701Z"
					fill="#6E0FEA"
				/>
				<path
					d="M154.009 35.0891C153.521 35.3687 153.034 35.5084 152.478 35.5084C151.573 35.5084 151.086 35.0192 151.086 33.9707V30.2661H154.217V27.6099H151.086V24.4645H148.859C148.859 26.3517 147.676 27.4701 146.075 27.54C146.005 27.54 145.866 27.54 145.797 27.54V29.1477V30.2661H147.745V34.2503C147.745 36.487 148.789 38.4442 151.921 38.4442C152.895 38.4442 153.869 38.1646 154.774 37.6753L154.009 35.0891Z"
					fill="#6E0FEA"
				/>
				<path
					d="M142.248 31.734L139.742 31.2447C139.186 31.1049 138.977 30.8952 138.977 30.4758C138.977 29.9166 139.533 29.637 140.16 29.637C141.552 29.637 141.9 30.5457 141.9 30.8952L144.962 30.2661C144.614 28.7982 143.222 27.1906 140.16 27.1906C137.794 27.1906 135.636 28.3788 135.636 30.7554C135.636 32.4329 136.68 33.4814 138.698 33.8309L140.856 34.2503C141.552 34.3901 141.9 34.6697 141.9 35.0192C141.9 35.5085 141.412 35.858 140.508 35.858C139.464 35.858 138.768 35.4386 138.629 34.5998L135.358 35.2988C135.636 36.9065 136.959 38.3743 140.299 38.3743C143.152 38.3743 145.101 37.1161 145.101 34.8095C145.17 33.1319 143.987 32.1534 142.248 31.734Z"
					fill="#6E0FEA"
				/>
			</svg>
		</StyledSpan>
	);
};
FullForecastLogo.SIZE = SIZE;
FullForecastLogo.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
